import QrReader from "./QrReader.tsx";

const ScanBag=()=>{
	return <QrReader/>;
}

export default ScanBag;